import React, { Component } from 'react'
import Axios from 'axios'
import { CARRIER_RESTRICTION_ACCOUNT,CARRIER_RESTRICTION_ACCOUNT_UPDATE, LOGIN_URL } from '../../../config/rest_endpoints'
import { getUser } from '../../../actions/session'
import Switch from "react-switch";
import CustomLoader from '../../common/loader';
import { Notifications } from '../../common/notification';
import { Redirect } from 'react-router-dom';

class CarrierRestriction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            data: [],
            userId: this.props.userId,
            active: false,
            isGetting:false,
            updatePayload:null,
            isDisable:true,
            isLoginURL: false
        }

        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.getCallRestric = this.getCallRestric.bind(this)
        this.updateCarrier = this.updateCarrier.bind(this)
    }

    componentDidMount() {
        this.getCallRestric()
    }

    getCallRestric() {
        const { User, userId } = this.state
        var headers = { 'Authorization': "Bearer " + User.token }
        this.setState({isGetting:true})
        Axios.get(`${CARRIER_RESTRICTION_ACCOUNT}/${userId}/carrier`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                var resp = res.data.data
                this.setState({
                    data: resp,
                    isGetting:false,
                })
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    toggleSwitch(obj,id) {
        const {data,User,userId} = this.state
        console.log(`obj`, obj)
        let update = {
            accountName:obj.accountName,
            active:!obj.active,
            id:obj.id
        }
        console.log(`update`, update)
        data.splice(id, 1, update);
        var payload = {
            "data":data
        }
        console.log(`payload`, payload)
        this.setState({updatePayload:payload, isDisable:false})
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.post(`${CARRIER_RESTRICTION_ACCOUNT}/${userId}/carrier`,payload, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                // this.getCallRestric()
            }
        }).catch(err => {
            const alert = err.response
            Notifications.notify(alert.data.message, "Failed", "error")

        })
    }

    renderCallRestriction() {
        const { data } = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (data === null) {
            return nullData
        }
        else {
            return data.map((row, idx) => {
                console.log(`row`, row)
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.accountName}</td>
                        <td style={{textAlign:'center'}}>{row.active === false ? <span className="badge badge-danger">Not Allowed</span> : <span className="badge badge-success">Allowed</span>}</td>
                        {/* <td><span className="size-1"><Switch height={20} width={50} onChange={this.toggleSwitch.bind(this, row,idx)} checked={row.active} /></span></td> */}
                        <td style={{textAlign:'center'}}><input className='myCheck' type="checkbox"  onChange={this.toggleSwitch.bind(this, row,idx)}  checked={row.active} /></td>
                    </tr>
                )
            })
        }
    }

    updateCarrier() {
        const {updatePayload,User,userId,data} = this.state
        console.log('updatePayload :>> ', updatePayload);
        this.setState({isGetting:true})
        var headers = { 'Authorization': "Bearer " + User.token }
        var payload = {
            "data":data
        }
        if(updatePayload === null) {
           
            this.setState({updatePayload:payload,isGetting:false})
        }
        else {
            Axios.post(`${CARRIER_RESTRICTION_ACCOUNT_UPDATE}/${userId}/carrier`,updatePayload, { headers }).then(res => {
                if (res) {
                    this.getCallRestric()
                    this.setState({isGetting:false, isDisable:true})
                    console.log('res :>> ', res);
                }
            }).catch(err => {
                const alert = err.response
                console.log(`alert.data.message`, alert.data.message)
                if (alert.data.message === 'invalid or expired jwt') {
                    localStorage.removeItem('user');
                    this.setState({ isLoginURL: true })
                    Notifications.notify(alert.data.message, "Token Expire", "error")
                }
                Notifications.notify(alert.data.message, "Failed", "error")
                this.setState({
                    isGetting: false
                })
            })
        }
       
    }

    render() {
        if (this.state.isLoginURL === true) {
            return <Redirect to={LOGIN_URL} ></Redirect>
        }
        return (
            <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body ">
                <div className="card-header header-elements-inline p-0 py-1">
                    <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                    <div className="header-elements">
                        <button type="submit" className="main-button btn btn-success btn-sm ml-3" disabled={this.state.isDisable ? true : false} onClick={this.updateCarrier} >Update Carrrier <i className="icon-database-insert ml-2"></i></button>
                    </div>
                </div>
                {/* <div className="card-body"> */}
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                                    <input type="search" className="" placeholder="Type to filter..."  aria-controls="DataTables_Table_0" />
                                </label> */}
                            </div>
                        </div>
                        <div className="datatable-scroll" style={{ overflowX: 'auto' }}>
                            <table style={{border:'1px solid #ddd',borderTop:'none',borderCollapse:'collapse'}} className="table table-striped no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Name</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Traffic</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isGetting ? <CustomLoader /> : this.renderCallRestriction()}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="datatable-footer">
                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 1 to 10 of 15 entries</div>
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div> */}
                    </div>
                {/* </div> */}
            </div>
        )
    }
}
export default CarrierRestriction